import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AnimationOnScroll } from "react-animation-on-scroll";
import Slider from "react-slick";

import CTABtnModule from "../../modules/cta_btn_module";
import ContentModule from "../../modules/content_module";
import ReviewRatings from "../../modules/review_rating_module";
import BannerSearch from "../Banner/Section/BannerSearch";
import BannerBtns from "../Banner/Section/BannerBtns";

import ValuationPage from "../ValuationPage/ValuationPage"
import FormsWrapper from "../FormPage/FormPage";
import ImageModule from "../../modules/image_module";


import "../Banner/Banner.scss";


const BannerSlider = ({Module, GQLPage}) => {

  //console.log("Module ==>", Module);

  const settings = {
    dots: false,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    pauseOnHover:false,
    arrows: false,
    mobileFirst: true,
    autoplay:true,
    autoplaySpeed:5000,
    fade: true
  };

  const ImageRenderList = ({item, imagename}) => {
    let processedImages = JSON.stringify({});
    if (GQLPage?.imagetransforms?.slider_component_image_Transforms) {
        processedImages = GQLPage?.imagetransforms?.slider_component_image_Transforms;
    }
    return (
      <ImageModule ImageSrc={item.image} title={item.title} altText={item.title} imagetransforms={processedImages} renderer="srcSet" imagename={imagename} strapi_id={GQLPage?.id} classNames="banner_img" />                           
    )
  }

  return (

      <section className="banner banner_slider">
        {/* <span className="banner_img" style={{backgroundImage:`url(${banner_section?.banner_image?.url})`}}></span> */}
        <Slider {...settings}>
          {Module?.slider_module.length > 0 && Module?.slider_module.map((item, index) =>{

            return(
              <div className={`slide_item`}>
                {/* {item?.image && <ImageModule ImageSrc={item?.image } imagetransforms={processedImages} altText={item?.title} strapi_id={GQLPage?.id} renderer="srcSet" imagename={imagename} classNames="banner_img"  />} */}

                {item?.image && <ImageRenderList item={item} imagename={"pages.slider_component_image.slider_image"} /> }   

                <span className="transp_bg"></span>

                <div className="banner-content">
                  <Container>
                    <Row>
                      <Col className="md-12">

                        <AnimationOnScroll animateIn="animate__fadeInUp" animateOnce={true}>
                          
                              {item?.title && (
                                index === 0 ? <h1>{item.title}</h1> : <div className="h1">{item.title}</div>
                                )
                              }

                              {item?.content && 
                              <span className="sm-text">
                                <ContentModule Content={item.content}/>
                              </span>
                              }

                              <div className="btn-wrapper">
                              {item?.button_cta?.length > 0 && item?.button_cta.map((cta, i)=> {
                                return(
                                  <CTABtnModule button_cta={cta}/>
                                )
                              }) }
                              </div>    


                              <div className="hidden_sec">
                              {Module?.show_reviews && 
                                <ReviewRatings id="false" />
                              }

                              {Module?.show_property_search && 
                                <BannerSearch GQLPage={GQLPage} />   
                              }   
                              </div>                      
             
                        </AnimationOnScroll>  
                        
                      </Col>
                    </Row>
                  </Container>
                  </div> 
                
              </div>
            )

          })}
        </Slider>
        
        <div className="banner_inner">

          <Container>
            <Row>
              <Col>
                {Module?.show_reviews && 
                  <ReviewRatings id="wd_id" />
                }

                {Module?.show_property_search && 
                  <BannerSearch GQLPage={GQLPage} />
                }
              </Col>
            </Row>
          </Container>
        </div>

      </section>

  );
};
export default BannerSlider;